const BASE_URL = '/api/contact/'

export const useContact = () => {
  const { fetchPost } = useCustomFetch()
  function sendContact(contact: Contact): Promise<void> {
    return fetchPost(BASE_URL + 'send', contact)
  }
  return {
    sendContact,
  }
}
